import { DEFINITIONS as ITALIC_DEFINITIONS } from '@xingternal/content-editor-plugin-italic';

import { ITALIC_TYPENAME } from '../constants';

const DEFINITIONS = { ...ITALIC_DEFINITIONS, __typename: ITALIC_TYPENAME };

const italicSerializer = ({ node, matchMark, createMark }) => {
  if (
    matchMark({
      node,
      match: DEFINITIONS,
    })
  ) {
    const { start, end } = node;
    if (start === end) return;
    return createMark({
      node,
      definitions: DEFINITIONS,
    });
  }
};

export { italicSerializer };
